import createSubmit from '../../Form/createSubmitButton.jsx'
import {name} from './ContactDetailForm.jsx'

export default createSubmit(name)